<template>
    <div>
        <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        <div class="row mb-2">
            <div class="col-lg-10" v-if="showPerPageProp && !selectXProp.options.length">
                <div class="form-group">
                    <label class="control-label">Buscar</label>
                    <input v-if="searchProp" class="form-control" type="text" v-model="search" :placeholder="searchPlaceholderProp">
                </div>
            </div>

            <div class="col-lg-8" v-else-if="!showPerPageProp && selectXProp.options.length">
                <div class="form-group">
                    <label class="control-label">Buscar</label>
                    <input v-if="searchProp" class="form-control" type="text" v-model="search" :placeholder="searchPlaceholderProp">
                </div>
            </div>

            <div class="col-lg-6" v-else-if="showPerPageProp && selectXProp.options.length">
                <div class="form-group">
                    <label class="control-label">Buscar</label>
                    <input v-if="searchProp" class="form-control" type="text" v-model="search" :placeholder="searchPlaceholderProp">
                </div>
            </div>

            <div class="col-lg-12" v-else>
                <div class="form-group">
                    <label class="control-label">Buscar</label>
                    <input v-if="searchProp" class="form-control" type="text" v-model="search" :placeholder="searchPlaceholderProp">
                </div>
            </div>

            <div class="col-lg-4" v-if="selectXProp.options.length">
                <div class="form-group">
                    <label class="control-label">{{ selectXProp.label }}</label>
                    <select class="form-control" v-model="tableData.selectx" @change="changeSelectx">
                        <option v-for="(option, index) in selectXProp.options" :key="index" :value="option.value">{{option.text}}</option>
                    </select>
                </div>
            </div>

            <div class="col-lg-2" v-if="showPerPageProp">
                <div class="form-group">
                    <label class="control-label">Por página</label>
                    <select class="form-control" v-model="tableData.length" @change="getData()">
                        <option v-for="(records, index) in perPageProp" :key="index" :value="records">{{records}}</option>
                    </select>
                </div>
            </div>
        </div>
        <header-datatable :columns="columns" :sortKey="sortKey" :sortOrders="sortOrders" @sort="sortBy">
            <tbody>
                <slot name="afterHeader" :data="apiData" :formatMoney="formatMoney"></slot>
                <tr v-for="(data, index) in apiData" :key="index" :class="[data.situation ? data.situation : '', data.situation2 ? data.situation2 : '', 'tbodyRowClass']">
                    <td v-for="(column, index2) in columns" :key="index2">
                        <span v-if="column.type === 'Date'">{{ formatDate(data[column.name]) }}</span>
                        <span v-else-if="column.type === 'DateTime'">{{ formatDate(data[column.name],'dateTime') }}</span>
<!--                            <span v-else-if="column.type === 'Currency'">R$ {{(data[column.name]).formatMoney(2, ',', '.') }}</span>-->
                        <span v-else-if="column.type === 'Currency'">R$ {{ formatMoney(data[column.name]) }}</span>
                        <span v-else-if="column.type === 'ObjectMultiDimensional'">
                            {{ column.key && column.key2 && data[column.name] ? 
                                (data[column.name][column.key] ? data[column.name][column.key][column.key2] : column.empty) : 
                                (column.key && data[column.name] ? data[column.name][column.key] : column.empty) }}
                            <!--
                            uso permite um ou 2 níveis e permite um default quando empty:
                                { width: '10%', label: 'IDENT.', name: 'config_boleto', type: 'ObjectMultiDimensional', key:'identification', sortable: false },
                                { width: '15%', label: 'PAGADOR.', name: 'transaction', type: 'ObjectMultiDimensional', key:'company', key2:'trading_name', empty:'Tansação excluída ou inexistente.', sortable: false },
                            -->
                        </span>
                        <span v-else-if="column.type === 'ObjectMultiDimensionalConcat'">{{ data[column.name] ? data[column.name][column.key] + ' ' + data[column.name][column.key1] + ' ' + data[column.name][column.key2] : '' }}</span>
                        <span v-else-if="column.type === 'Change'" v-html="column.change[data[column.name]]"></span> <!-- { width: '20%', label: 'TIPO', name: 'type', type: 'Change', change:{ video: 'Vídeo', image: 'Imagem', audio: 'Áudio', pdf: 'PDF' }, sortable: true },-->
                        <span v-else-if="column.type === 'Bool'" v-html="data[column.name] ? column.bool.true : column.bool.false"></span> <!-- { width: '15%', label: 'SITUAÇÃO', name: 'canceled', type: 'Bool', bool:{  true : 'Cancelado', false: 'Ativo' }, sortable: true },-->

                        <span v-else-if="column.type === 'Array'"><span v-for="(item, index3) in data[column.name]" :key="data[column.name]+index3"> {{data[column.name].length > 1 && index3 > 0 && item[column.key] != '' ? '|' : '' }} {{ item[column.key] }}</span></span>
                        <span v-else-if="column.type === 'Slot'">
                            <!-- O tipo Slot permite que eu receba os dados da linha e insira no local da coluna onde eu defini esse tipo os valores que eu quiser -->
                            <slot :name="column.name" :data="data" :formatMoney="formatMoney" :moment="moment" :index="index"></slot>
                        </span>
                        <span v-else-if="column.type !== 'action'">{{ data[column.name] }}</span>
                        <span v-else>
                            <dropdown ref="dropdown" menu-right>
                                <btn type="success" class="dropdown-toggle">Ação <span class="caret"></span></btn>
                                <template slot="dropdown">
                                    <slot name="action" :data="data" :index="index"></slot>
                                </template>
                            </dropdown>
                        </span>
                    </td>
                </tr>
                <slot name="beforePagination" :data="apiData" :formatMoney="formatMoney"></slot>
                <tr v-if="!apiData.length">
                    <td :colspan="columns.length">
                        <alert type="warning">
                            <p class="h4 d-flex align-items-center">
                                <i class="fa fa-exclamation-triangle fa-3x" aria-hidden="true"></i> 
                                <slot name="noResult">Nenhum resultado encontrado.</slot>
                            </p>
                        </alert>
                    </td>
                </tr>
            </tbody>
        </header-datatable>
        <hr>
        <div class="row">
            <div class="col-lg-6">
                <br>Mostrando de {{pagination.from}} até {{pagination.to}} de {{pagination.total}} registros.
            </div>
            <div class="col-lg-6" v-if="pagination.lastPage > 1">
                <pagination align="right" v-model="pagination.currentPage" @input="changePage" :total-page="pagination.lastPage" boundary-links/>
            </div>
        </div>
        <slot name="afterPagination" :data="apiData" :formatMoney="formatMoney"></slot>
    </div>
</template>

<script>
    import HeaderDatatable from './header-datatable-component';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import moment from "moment";

    export default {
        name: 'datatable-component',
        components: { HeaderDatatable, Loading },

        props: {
            searchProp: { type: Boolean, default: true },
            showPerPageProp: { type: Boolean, default: true },
            searchPlaceholderProp: { type: String, default: 'Buscar...' },
            selectXProp: { type: Object, default() { return {label: '', options: [] } } },
            perPageProp: { type: Array, default() { return ['10', '20', '30'] } },
            columnsProp: { type: Array, required:true }, //Array de objetos ex.: [ {width: '5%', label: 'ID', name: 'id', sortable: true }, {width: '30%', label: 'NOME', name: 'name', sortable: true }]
            urlProp: { type: String, required: true },
            methodProp: { type: String, default: 'POST' }, //por enquanto trabalhando somente com POST
            defaultOrderProp: { type: String, default: 'id' },
            defaultOrderDir: { type: String, default: 'asc' },
            tableDataSendRequestProp: { type: Object }
        },

        computed: {
            moment() {
                return moment;
            },
        },

        created() {
            /** Inserir no objeto  tableData os dados adicionais a serem enviados ao servidor */
            Object.assign(this.tableData, this.tableDataSendRequestProp);

            this.getData();

            // _.debounce é uma função fornecida pelo lodash para limitar a frequência que uma operação complexa pode ser executada.
            // Neste caso, queremos limitar a frequência com que acessamos a api, esperando que o usuário termine completamente
            // a digitação antes de realizar a chamada Ajax. Para aprender mais sobre a função _.debounce (e sua prima _.throttle),
            // visite: https://lodash.com/docs#debounce
            this.debouncedGetData = _.debounce(this.getData, 500);
        },

        beforeDestroy () {
            //
        },

        watch: {
            search(newSearchVal, oldSearchValValue) {
                this.tableData.search = newSearchVal
                this.debouncedGetData()
            },
            
            /** Se alterar o prop das colunas reinicia */
            columnsProp(newValue, oldValue) {
                const mantendoSelectx = this.tableData.selectx //para não resetar o selectx, pois se ocorrer o valor selecionado por padrão volta
                Object.assign(this.$data, this.$options.data.call(this));
                this.tableData.selectx = mantendoSelectx
                this.$forceUpdate()
            }
        },

        data () {
            let sortOrders = {};
            let columns = this.columnsProp;
            columns.forEach((column) => {
                sortOrders[column.name] = column.name == this.defaultOrderProp ? 1 : -1;
            });
            const selectx = this.selectXProp.options.find((obj) => obj.hasOwnProperty('selected'))
            return {
                optionsToast: { timeout: 6000, position: 'topCenter' },
                isLoading: false,
                fullPage: false,

                apiData: [],
                columns: columns,
                sortKey: this.defaultOrderProp,
                sortOrders: sortOrders,
                search: '',
                tableData: {
                    draw: 0,
                    length: 10,
                    column: this.getIndex(columns, 'name', this.defaultOrderProp),//ordenação inicial
                    dir: this.defaultOrderDir,
                    search: '',
                    selectx: selectx ? selectx.value : '',
                    columns: columns.map(value => value.name)
                },
                pagination: {
                    lastPage: '',
                    currentPage: 1,
                    total: 1,
                    lastPageUrl: '',
                    nextPageUrl: '',
                    prevPageUrl: '',
                    from: '',
                    to: ''
                },
            }
        },

        methods: {
            formatMoney(amount, decimalCount = 2, decimal = ",", thousands = ".") {
                try {
                    decimalCount = Math.abs(decimalCount);
                    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

                    const negativeSign = amount < 0 ? "-" : "";

                    let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
                    let j = (i.length > 3) ? i.length % 3 : 0;

                    return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
                } catch (e) {
                    console.log(e)
                }
            },

            changeSelectx () {
                this.search = ''
                this.$emit('changeSelectx', this.tableData.selectx)
            },

            formatDate(dateTimeString = null, type = 'date') {
                if(dateTimeString) {
                    if(type == 'date'){ // A data passada deve estar no padrão: YYYY-MM-DD
                        const [YYYY, MM, DD] = (dateTimeString.slice(0,10)).split('-');
                        return `${DD}/${MM}/${YYYY}`;
                    } else if(type == 'time'){
                        return dateTimeString
                    } else if(type == 'dateTime'){ // A data passada deve estar no padrão: YYYY-MM-DD HH:mm:ss
                        const [YYYY, MM, DD] = (dateTimeString.slice(0,10)).split('-');
                        const [H, m, s] = (dateTimeString.slice(11,19)).split(':');
                        return `${DD}/${MM}/${YYYY} ${H}:${m}:${s}`;
                    }
                    return dateTimeString

                    // // DD/MM/YYYY HH:mm:ss
                    // // Primeiro, dividimos a data completa em duas partes:
                    // const [date, time] = dateTimeString.split(' ');
                    //
                    //
                    // // Dividimos o tempo em hora e minutos:
                    // const [HH, mm, ss] = time.split(':');
                    //
                    // // Retornamos a data formatada em um padrão compatível com ISO:
                    // return `${DD}/${MM}/${YYYY}T${HH}:${mm}:${ss}`;
                }
                return '';
            },

            getData(url = this.urlProp, method = this.methodProp, data = this.tableData) {
                this.tableData.draw++;
                this.isLoading = true;
                axios({method, url, data})
                    .then(response => {
                        if (this.tableData.draw == response.data.draw) {
                            this.apiData = response.data.data.data;
                            this.configPagination(response.data.data);
                        }
                        this.isLoading = false;
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log(error.response);
                        if (error.response.status === 401 || error.response.status === 419) {
                            this.$toast.warning('Sua sessão expirou. Por favor atualize a página.', 'AVISO', this.optionsToast);
                        } else {
                            this.$toast.error(error.response.data.message, 'Erro', this.optionsToast);
                        }
                    });
            },

            changePage() {
                this.getData(this.urlProp + '?page=' + this.pagination.currentPage);
            },

            configPagination(data) {
                this.pagination.lastPage = data.last_page;
                this.pagination.currentPage = data.current_page;
                this.pagination.total = data.total;
                this.pagination.lastPageUrl = data.last_page_url;
                this.pagination.nextPageUrl = data.next_page_url;
                this.pagination.prevPageUrl = data.prev_page_url;
                this.pagination.from = data.total === 0 ? 0 : data.from;
                this.pagination.to = data.total === 0 ? 0 : data.to;
                this.pagination.perPage = data.per_page;
            },

            sortBy(column) {
                if (column.sortable) {
                    this.sortKey = column.name;
                    this.sortOrders[column.name] = this.sortOrders[column.name] * -1;
                    this.tableData.column = this.getIndex(this.columns, 'name', column.name);
                    this.tableData.dir = this.sortOrders[column.name] === 1 ? 'asc' : 'desc';
                    this.getData();
                }
                return true;
            },

            //Todo Mixins
            getIndex(array, key, value) {
                return array.findIndex(i => i[key] == value)
            },

            reload(data, clearSearch = false) {
                Object.assign(this.tableData, data);//data deve ser objeto
                // TODO ao fazer um reload com clearSearch = true, se o search não tiver sido alterado faz só o getData mas se o
                // TODO search tiver sido alterado faz 2 get data (um do whatch e outro do próprio gtData) evitar 2 getdatas
                if(clearSearch)
                    this.clearSearch()
                this.getData();
            },

            clearSearch() {
                this.search = ''
            },
        }
    };
</script>

<style scoped>

</style>